import { render } from "./Charts.vue?vue&type=template&id=1a56c75c&scoped=true"
import script from "./Charts.vue?vue&type=script&lang=js"
export * from "./Charts.vue?vue&type=script&lang=js"

import "./Charts.vue?vue&type=style&index=0&id=1a56c75c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a56c75c"]])

export default __exports__